module.exports = __webpack_public_path__ + "img/cover.85572ab6.jpg";